// Comprehensive international grade level system
export const EDUCATION_SYSTEMS = {
  US: 'American System',
  UK: 'British System',
  INTERNATIONAL: 'International System',
  MIXED: 'All Systems'
};

export const GRADE_LEVELS = {
  // American System
  US: [
    { value: 'Pre-K (Age 3-4)', label: 'Pre-K (Age 3-4)', system: 'US', ageRange: '3-4' },
    { value: 'Kindergarten (Age 5)', label: 'Kindergarten (Age 5)', system: 'US', ageRange: '5' },
    { value: 'Grade 1 (Age 6)', label: 'Grade 1 (Age 6)', system: 'US', ageRange: '6' },
    { value: 'Grade 2 (Age 7)', label: 'Grade 2 (Age 7)', system: 'US', ageRange: '7' },
    { value: 'Grade 3 (Age 8)', label: 'Grade 3 (Age 8)', system: 'US', ageRange: '8' },
    { value: 'Grade 4 (Age 9)', label: 'Grade 4 (Age 9)', system: 'US', ageRange: '9' },
    { value: 'Grade 5 (Age 10)', label: 'Grade 5 (Age 10)', system: 'US', ageRange: '10' },
    { value: 'Grade 6 (Age 11)', label: 'Grade 6 (Age 11)', system: 'US', ageRange: '11' },
    { value: 'Grade 7 (Age 12)', label: 'Grade 7 (Age 12)', system: 'US', ageRange: '12' },
    { value: 'Grade 8 (Age 13)', label: 'Grade 8 (Age 13)', system: 'US', ageRange: '13' },
    { value: 'Grade 9 (Age 14)', label: 'Grade 9 (Age 14)', system: 'US', ageRange: '14' },
    { value: 'Grade 10 (Age 15)', label: 'Grade 10 (Age 15)', system: 'US', ageRange: '15' },
    { value: 'Grade 11 (Age 16)', label: 'Grade 11 (Age 16)', system: 'US', ageRange: '16' },
    { value: 'Grade 12 (Age 17)', label: 'Grade 12 (Age 17)', system: 'US', ageRange: '17' },
    { value: 'College/University', label: 'College/University', system: 'US', ageRange: '18+' }
  ],

  // British System
  UK: [
    { value: 'Reception (Age 4-5)', label: 'Reception (Age 4-5)', system: 'UK', ageRange: '4-5' },
    { value: 'Year 1 (Age 5-6)', label: 'Year 1 (Age 5-6)', system: 'UK', ageRange: '5-6' },
    { value: 'Year 2 (Age 6-7)', label: 'Year 2 (Age 6-7)', system: 'UK', ageRange: '6-7' },
    { value: 'Year 3 (Age 7-8)', label: 'Year 3 (Age 7-8)', system: 'UK', ageRange: '7-8' },
    { value: 'Year 4 (Age 8-9)', label: 'Year 4 (Age 8-9)', system: 'UK', ageRange: '8-9' },
    { value: 'Year 5 (Age 9-10)', label: 'Year 5 (Age 9-10)', system: 'UK', ageRange: '9-10' },
    { value: 'Year 6 (Age 10-11)', label: 'Year 6 (Age 10-11)', system: 'UK', ageRange: '10-11' },
    { value: 'Year 7 (Age 11-12)', label: 'Year 7 (Age 11-12)', system: 'UK', ageRange: '11-12' },
    { value: 'Year 8 (Age 12-13)', label: 'Year 8 (Age 12-13)', system: 'UK', ageRange: '12-13' },
    { value: 'Year 9 (Age 13-14)', label: 'Year 9 (Age 13-14)', system: 'UK', ageRange: '13-14' },
    { value: 'Year 10 (Age 14-15)', label: 'Year 10 (Age 14-15)', system: 'UK', ageRange: '14-15' },
    { value: 'Year 11 (Age 15-16)', label: 'Year 11 (Age 15-16)', system: 'UK', ageRange: '15-16' },
    { value: 'Year 12 (Age 16-17)', label: 'Year 12 (Age 16-17)', system: 'UK', ageRange: '16-17' },
    { value: 'Year 13 (Age 17-18)', label: 'Year 13 (Age 17-18)', system: 'UK', ageRange: '17-18' },
    { value: 'University', label: 'University', system: 'UK', ageRange: '18+' }
  ],

  // International System (Common international school structure)
  INTERNATIONAL: [
    { value: 'Early Years (Age 3-5)', label: 'Early Years (Age 3-5)', system: 'INTL', ageRange: '3-5' },
    { value: 'Primary 1 (Age 5-6)', label: 'Primary 1 (Age 5-6)', system: 'INTL', ageRange: '5-6' },
    { value: 'Primary 2 (Age 6-7)', label: 'Primary 2 (Age 6-7)', system: 'INTL', ageRange: '6-7' },
    { value: 'Primary 3 (Age 7-8)', label: 'Primary 3 (Age 7-8)', system: 'INTL', ageRange: '7-8' },
    { value: 'Primary 4 (Age 8-9)', label: 'Primary 4 (Age 8-9)', system: 'INTL', ageRange: '8-9' },
    { value: 'Primary 5 (Age 9-10)', label: 'Primary 5 (Age 9-10)', system: 'INTL', ageRange: '9-10' },
    { value: 'Primary 6 (Age 10-11)', label: 'Primary 6 (Age 10-11)', system: 'INTL', ageRange: '10-11' },
    { value: 'Secondary 1 (Age 11-12)', label: 'Secondary 1 (Age 11-12)', system: 'INTL', ageRange: '11-12' },
    { value: 'Secondary 2 (Age 12-13)', label: 'Secondary 2 (Age 12-13)', system: 'INTL', ageRange: '12-13' },
    { value: 'Secondary 3 (Age 13-14)', label: 'Secondary 3 (Age 13-14)', system: 'INTL', ageRange: '13-14' },
    { value: 'Secondary 4 (Age 14-15)', label: 'Secondary 4 (Age 14-15)', system: 'INTL', ageRange: '14-15' },
    { value: 'Secondary 5 (Age 15-16)', label: 'Secondary 5 (Age 15-16)', system: 'INTL', ageRange: '15-16' },
    { value: 'IB Diploma 1 (Age 16-17)', label: 'IB Diploma 1 (Age 16-17)', system: 'INTL', ageRange: '16-17' },
    { value: 'IB Diploma 2 (Age 17-18)', label: 'IB Diploma 2 (Age 17-18)', system: 'INTL', ageRange: '17-18' },
    { value: 'Higher Education', label: 'Higher Education', system: 'INTL', ageRange: '18+' }
  ]
};

// Combined list for "All Systems" view
export const ALL_GRADE_LEVELS = [
  ...GRADE_LEVELS.US,
  ...GRADE_LEVELS.UK,
  ...GRADE_LEVELS.INTERNATIONAL
].sort((a, b) => {
  // Sort by age range start
  const getAgeStart = (ageRange) => {
    if (ageRange === '18+') return 18;
    return parseInt(ageRange.split('-')[0]);
  };
  return getAgeStart(a.ageRange) - getAgeStart(b.ageRange);
});

// Legacy grade levels for backward compatibility
export const LEGACY_GRADE_LEVELS = [
  'Elementary (K-5)',
  'Middle School (6-8)',
  'High School (9-12)',
  'College/University'
];

// Helper functions
export const getGradeLevelsBySystem = (system) => {
  if (system === 'MIXED') return ALL_GRADE_LEVELS;
  return GRADE_LEVELS[system] || [];
};

export const getEducationSystemFromGradeLevel = (gradeLevel) => {
  for (const [system, levels] of Object.entries(GRADE_LEVELS)) {
    if (levels.find(level => level.value === gradeLevel)) {
      return system;
    }
  }
  return 'US'; // Default fallback
};

export const isLegacyGradeLevel = (gradeLevel) => {
  return LEGACY_GRADE_LEVELS.includes(gradeLevel);
};

// Convert legacy grade levels to new system
export const convertLegacyGradeLevel = (legacyGrade) => {
  const conversions = {
    'Elementary (K-5)': 'Grade 3 (Age 8)', // Middle of elementary
    'Middle School (6-8)': 'Grade 7 (Age 12)', // Middle of middle school
    'High School (9-12)': 'Grade 10 (Age 15)', // Middle of high school
    'College/University': 'College/University'
  };
  return conversions[legacyGrade] || legacyGrade;
};

// Educational stages for curriculum alignment
export const EDUCATIONAL_STAGES = {
  'EARLY_YEARS': { label: 'Early Years', ageRange: '3-5', description: 'Foundation skills development' },
  'PRIMARY': { label: 'Primary/Elementary', ageRange: '5-11', description: 'Core academic foundations' },
  'LOWER_SECONDARY': { label: 'Lower Secondary/Middle School', ageRange: '11-14', description: 'Subject specialization begins' },
  'UPPER_SECONDARY': { label: 'Upper Secondary/High School', ageRange: '14-18', description: 'Exam preparation and advanced topics' },
  'HIGHER_EDUCATION': { label: 'Higher Education', ageRange: '18+', description: 'University and professional studies' }
};

export const getEducationalStage = (gradeLevel) => {
  const level = ALL_GRADE_LEVELS.find(l => l.value === gradeLevel);
  if (!level) return EDUCATIONAL_STAGES.PRIMARY;

  const ageStart = parseInt(level.ageRange.split('-')[0]);

  if (ageStart <= 5) return EDUCATIONAL_STAGES.EARLY_YEARS;
  if (ageStart <= 11) return EDUCATIONAL_STAGES.PRIMARY;
  if (ageStart <= 14) return EDUCATIONAL_STAGES.LOWER_SECONDARY;
  if (ageStart <= 18) return EDUCATIONAL_STAGES.UPPER_SECONDARY;
  return EDUCATIONAL_STAGES.HIGHER_EDUCATION;
};